import React, { useState } from 'react';
import icon_back from '../assets/img/icon-back.svg';
import icon_next from '../assets/img/icon-next.svg';
import '../css/components/Carousel.css';

const Carousel = ({ items }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + items.length) % items.length);
  };

  return (
    <div className="carousel">
      <div className="carousel-content bg-sphericaMainDefault">
        <div className="carousel-text ">
          <img src={items[currentIndex].icon} alt='carousel' />
          <div>
            <span className='font-bbvaMedium'>{items[currentIndex].offer}</span>
            <p className='font-bbvaLight'>{items[currentIndex].description}</p>
          </div>
        </div>
      </div>

      <div className="carousel-footer">
          <div className="carousel-counter bg-sphericaSecondary">
            {currentIndex + 1} de {items.length}
          </div>
          <div className="carousel-controls">
            <img src={icon_back} alt='control back' onClick={prevSlide} />
            <img src={icon_next} alt='control next' onClick={nextSlide} />
          </div>
      </div>
    </div>
  );
};

export default Carousel;